import { Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { CloudProvider } from 'src/app/core/models/cloudProvider';
import { DeploymentParameter, DeploymentJsonBody } from 'src/app/core/models/deployment';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { FormArray, FormBuilder, FormControl, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { StepperOrientation } from '@angular/material/stepper';
import { Observable } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { AddNewCredentialComponent } from 'src/app/modules/credential/modals/add-new-credential/add-new-credential.component';
import { CloudTypes } from 'src/app/core/models/globals';
import { AddNodeConfiguratorComponent } from 'src/app/modules/pages/configurator/node-configurator/add-node-configurator/add-node-configurator.component';

interface SavedNodeConfig {
  hostNames: string;
  hostNodeSizes: string;
  offeredImages: string;
  hostNodeIPs: string;
}

@Component({
  selector: 'app-add-kvm-deployment',
  templateUrl: './add-kvm-deployment.component.html',
  styleUrls: ['./add-kvm-deployment.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddKvmDeploymentComponent implements OnInit {
  hidePassword = true;
  stepperOrientation: Observable<StepperOrientation>;
  currentUserRole = this.authenticationService.getRole() == '' ? null : this.authenticationService.getRole();
  showSkipDeployment: boolean = true;
  cloudName: string = this.data.provider.providerName;
  cloudValue: number = +this.data.provider.providerValue;
  image: string = this.data.provider.providerIconFileName;
  isLoading = false;
  activeTab = 'deployment';

  deploymentConfigurationForm: FormGroup;
  nodeConfigurationForm: FormGroup;
  hpcConfigs: string[] = [];
  credentials: string[] = [];
  images: string[] = [];
  activeTabIndex = 0;
  deploymentForm: FormGroup;

  nodeConfigForm: FormGroup;
  showNodeForm = false;
  savedNodeConfigs: SavedNodeConfig[] = [];
  
  tabs = [
    { label: 'Basics', disabled: false },
    { label: 'Node', disabled: false },
    { label: 'Review', disabled: false }
  ];
  isNodeTabEnabled = false;
  @ViewChild('skipDeployment') skipDeployment: ElementRef;
  syncHosts = false;
  syncVMs = false;
  syncKvm = true;
  availableHosts: any[] = [];
  selectedHosts: any[] = [];
  availableVMs: any[] = [];
  selectedVMs: any[] = [];
  maskedPassword = '';
  isMasked = true;
  hostSearchTerm = '';
  vmSearchTerm = '';
  filterText;
  isFormSubmitted;
  filteredWorkstations: any[];
  multiSelectIndex = [];
  isSelectAll: boolean = false;
  filtersApplied: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddKvmDeploymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { provider: CloudProvider },
    public depService: DeploymentService,
    private authenticationService: AuthenticationService,
    private fb: FormBuilder,
    breakpointObserver: BreakpointObserver,
    private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar,
    public dialog: MatDialog
  ) {
    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 800px)')
      .pipe(map(({matches}) => (matches ? 'horizontal' : 'vertical')));
  }

  ngOnInit(): void {
    this.spinner.show('addDeployment');
    if (
      this.cloudName?.toLowerCase().includes('vdi') ||
      this.cloudName?.toLowerCase().includes('kvm')
    ) {
      this.showSkipDeployment = false;
    }
    if (!this.currentUserRole) {
      this.snackbar.open('You do not have permission to add new deployment.', 'Ok');
    }
    this.nodeConfigForm = this.fb.group({
      hostNames: ['', Validators.required],
      hostNodeSizes: ['', Validators.required],
      offeredImages: ['', Validators.required],
      hostNodeIPs: ['', Validators.required]
    });
    this.loadDataToCreateDeployment(true);
    this.initForms();
  }

  loadDataToCreateDeployment(initForm = false) {
    this.depService.getCloudProviderDetailsForStaticDep(this.cloudValue, this.cloudName)
      .subscribe({
        next: (data: any) => {
          if(data){
            var deploymentJsonBody = JSON.parse(data);
            if(deploymentJsonBody) {
              if(deploymentJsonBody.hpcConfigs){
                this.hpcConfigs = deploymentJsonBody.hpcConfigs;
              }
              if(deploymentJsonBody.credentials){
                this.credentials = deploymentJsonBody.credentials;
              }
              if(deploymentJsonBody.images){
                this.images = deploymentJsonBody.images;
              }
              if(initForm){
                this.initForms();
              }
              this.spinner.hide('addDeployment');
            }
          }
        },
        error: (error) => {
          console.error(error);
          this.spinner.hide('addDeployment');
        },
        complete: () => {
          this.spinner.hide('addDeployment');
        }
      })
  }

  initForms() {
    this.deploymentForm = new FormGroup({
      deployment: new FormGroup({
        deploymentName: new FormControl("", [Validators.required, Validators.pattern("^[a-z][a-z0-9-]{2,12}[a-z0-9]$")]),
        Location: new FormControl("", Validators.required),
        adminPassword: new FormControl(""),
        adminUserName: new FormControl(""),
        credentials: new FormControl("", Validators.required),
        syncKvm: new FormControl(true)
      }),
      node: new FormGroup({
        hpcConfig: new FormControl("", Validators.required),
        syncHosts: new FormControl(true),
        syncVMs: new FormControl(false)
      }),
      other: new FormGroup({
        usePublicIPorHNConnect: new FormControl("false"),
      })
    });
    


    if(this.hpcConfigs && this.hpcConfigs.length > 0){
      this.deploymentForm.get('node.hpcConfig').setValue(this.hpcConfigs[0]);
      this.nodeConfigForm.get('hostNodeSizes').setValue(this.hpcConfigs[0]);
    }
    if(this.credentials && this.credentials.length > 0){
      this.deploymentForm.get('deployment.credentials').setValue(this.credentials[0]);
      this.getHostsAndMachinesFromKvm(this.credentials[0]);
    }
    if(this.images && this.images.length > 0){
      this.nodeConfigForm.get('offeredImages').setValue(this.images[0]);
    }

    this.deploymentForm.get('deployment.credentials')?.valueChanges.subscribe(value => {
      this.getHostsAndMachinesFromKvm(value);
    });
  }

  onCancel() {
    this.snackbar.dismiss();
    this.dialogRef.close();
  }

  setActiveTab(index: number) {
    if (!this.tabs[index].disabled) {
      this.activeTabIndex = index;
    }
    if (index === 1) {
      this.onNodeTabEnter();
    }
  }

  onSyncChange(change: boolean) {
    this.syncKvm = change;
    this.tabs[1].disabled = !change;
    this.isNodeTabEnabled = change;

    if (!change) {
      this.selectedHosts = [];
      this.selectedVMs = [];
      this.multiSelectIndex = [];

      if (this.activeTabIndex == 1) {
        this.setActiveTab(0);
      }
    }
  }

  navigateToPreviousTab() {
    for (let i = this.activeTabIndex - 1; i >= 0; i--) {
      if (!this.tabs[i].disabled) {
        this.setActiveTab(i);
        return;
      }
    }
  }

  navigateToNextTab() {
    for (let i = this.activeTabIndex + 1; i < this.tabs.length; i++) {
      if (!this.tabs[i].disabled) {
        this.setActiveTab(i);
        return;
      }
    }
  }

  createNewCreds(){
    const dialogRef = this.dialog.open(AddNewCredentialComponent, {
          disableClose: true,
          width: "600px",
          data: { cloudValue: 6, cloudName: CloudTypes.KVM, updateForm: false, friendlyName: "", maxHeight: "50vh"},
        });
        dialogRef.afterClosed().subscribe((res) => {
          if (res.res) {
            this.spinner.show('addDeployment');
            this.loadDataToCreateDeployment(false);
            this.snackbar.open("New credential added successfully", "Ok", { duration: 3000 });
          }
          else {
            this.loadDataToCreateDeployment(false);
          }
        });
  }

  createNewHpcConfig(){
    const dialogRef = this.dialog.open(AddNodeConfiguratorComponent, {
      width: '40%',
      height: '70%',
      autoFocus: true,
      disableClose: false,
    }).afterClosed().subscribe((res) => {
      this.loadDataToCreateDeployment(false);
    });
  }

  initNodeConfigForm(): void {
    this.nodeConfigForm = this.fb.group({
      hostNames: ['', Validators.required],
      hostNodeSizes: ['', Validators.required],
      offeredImages: ['', Validators.required],
      hostNodeIPs: ['', Validators.required]
    });
    if(this.hpcConfigs && this.hpcConfigs.length > 0){
      this.nodeConfigForm.get('hostNodeSizes').setValue(this.hpcConfigs[0]);
    }
    if(this.images && this.images.length > 0){
      this.nodeConfigForm.get('offeredImages').setValue(this.images[0]);
    }
  }

  openNodeForm(): void {
    this.showNodeForm = true;
    this.initNodeConfigForm();
  }

  cancelNodeForm(): void {
    this.showNodeForm = false;
  }

  saveNodeConfig(): void {
    if (this.nodeConfigForm.valid) {
      const newConfig: SavedNodeConfig = {
        hostNames: this.nodeConfigForm.value.hostNames,
        hostNodeSizes: this.nodeConfigForm.value.hostNodeSizes,
        offeredImages: this.nodeConfigForm.value.offeredImages,
        hostNodeIPs: this.nodeConfigForm.value.hostNodeIPs
      };

      if(this.savedNodeConfigs && this.savedNodeConfigs.length > 0){
        if(this.savedNodeConfigs.findIndex(x => x.hostNames == newConfig.hostNames) != -1){
          this.snackbar.open("Host node with same name already selected.", "Ok", { duration: 3000 })
        }
        else{
          if(this.savedNodeConfigs.findIndex(x => x.hostNodeIPs == newConfig.hostNodeIPs) != -1){
            this.snackbar.open("Host node with same ip already selected.", "Ok", { duration: 3000 })
          }
          else{
            this.savedNodeConfigs.push(newConfig);
            this.deploymentForm.get('node.hpcConfig').setValue(this.savedNodeConfigs);
            this.showNodeForm = false;
          }
        }
      }
      else{
        this.savedNodeConfigs.push(newConfig);
        this.deploymentForm.get('node.hpcConfig').setValue(this.savedNodeConfigs);
        this.showNodeForm = false;
      }
    }
  }

  removeNodeConfig(index: number): void {
    const configName = this.savedNodeConfigs[index].hostNames;
    const configIndex = this.hpcConfigs.findIndex(config => config === configName);
    
    if (configIndex > -1) {
      this.hpcConfigs.splice(configIndex, 1);
    }
    
    this.savedNodeConfigs.splice(index, 1);
    if (this.deploymentForm.get('node.hpcConfig').value === configName) {
      this.deploymentForm.get('node.hpcConfig').reset();
    }
  }

  maskInput(event: any) {
    const rawValue = event.target.value;
    this.maskedPassword = this.isMasked ? '*'.repeat(rawValue.length) : rawValue;
  }

  toggleMask() {
    this.isMasked = !this.isMasked;
  }

  onSubmit() {
    if (this.deploymentForm.valid) 
    {
      if (!this.currentUserRole) return;
      // let skipCloudDep;
      // if (this.skipDeployment) {
      //   skipCloudDep = (<any>this.skipDeployment).checked;
      // }

      let depParams: DeploymentParameter[] = [];

      const formControls = this.deploymentForm.controls;

      for (let section in formControls) {
        if (formControls[section] instanceof FormGroup) {
          let group = formControls[section] as FormGroup;
          for (let key in group.controls) {
            let control = group.get(key);
            
            if (control?.hasError('required') && !control.value) {
              this.snackbar.open(`${key} Required!`, 'Ok');
              return false;
            }

            if (control?.hasError('pattern')) {
              this.snackbar.open(`${key} is Invalid!`, 'Ok');
              return false;
            }

            if(key == 'credentials') {
              key = 'Credentials';
            }


            if(key == "syncHosts" || key == "syncVMs" || key == "syncKvm"){
              depParams.push({ depKey: key, depValue: control.value?.toString() });
            }
            else{
              depParams.push({ depKey: key, depValue: control.value });
            }
          }
        }
      }

      if(this.availableHosts && this.availableHosts.length > 0){
        depParams.push({ depKey: 'hostMachinesToSync', depValue: JSON.stringify(this.availableHosts) })
      }
      else{
        depParams.push({ depKey: 'hostMachinesToSync', depValue: '' })
      }

      if(this.multiSelectIndex && this.multiSelectIndex.length > 0) {
        this.selectedVMs = this.availableVMs.filter((vm) => this.multiSelectIndex.includes(vm.vmNames));
      }

      if(this.deploymentForm.get('deployment.syncKvm')){
        depParams.push({ depKey: 'vmsToSync', depValue: JSON.stringify(this.selectedVMs) })
      }
      else{
        depParams.push({ depKey: 'vmsToSync', depValue: '' })
      }
      
      depParams.push({ depKey: 'storageAccountName', depValue: this.cloudName });
      depParams.push({ depKey: 'storageSize', depValue: '4096' });

      var depJsonBody = new DeploymentJsonBody(depParams);
      this.spinner.show('addDeployment');
      if (this.showSkipDeployment) 
      {
        this.depService
          .createDeployment(
            this.cloudValue,
            this.cloudName,
            depJsonBody,
            false
          )
          .subscribe({
            next: (data) => {
              this.spinner.show('addDeployment');
              this.dialogRef.close(depParams);
            },
            error: (err) => {
              this.snackbar.open(err?.error?.actionMessage || "Something went wrong.", 'Ok', {
                duration: 10000,
              });
              this.spinner.hide('addDeployment');
            },
          });
      } 
      else 
      {
        this.depService
          .createDeployment(this.cloudValue, this.cloudName, depJsonBody, true)
          .subscribe({
            next: (data) => {
              this.spinner.show('addDeployment');
              this.dialogRef.close(depParams);
            },
            error: (err) => {
              this.snackbar.open(err?.error?.actionMessage || "Something went wrong.", 'Ok', {
                duration: 10000,
              });
              this.spinner.hide('addDeployment');
            },
          });
      }
    }
    else 
    {
      Object.keys(this.deploymentForm.controls).forEach(key => {
        const control = this.deploymentForm.get(key);
        control?.markAsTouched();
      });
    }
  }

  // setSyncHosts(value: boolean) {
  //   this.syncHosts = value;
  //   this.deploymentForm.get('node.syncHosts')?.setValue(value);
  //   let friendlyName = this.deploymentForm.get('deployment.credentials')?.value
  //   if(friendlyName){
  //     this.getHostsAndMachinesFromKvm(friendlyName);
  //   }
    
  //   if (!value) {
  //     this.resetHostSelections();
  //   }
  // }
  
  setSyncVMs(value: boolean) {
    this.deploymentForm.get('node.syncVMs')?.setValue(value);
    let friendlyName = this.deploymentForm.get('deployment.credentials')?.value
    if(friendlyName){
      this.getHostsAndMachinesFromKvm(friendlyName);
    }
    if (!value) {
      this.resetVMSelections();
    }
  }
  
  resetHostSelections() {
    this.availableHosts.forEach(host => host.selected = false);
    this.selectedHosts = [];
  }
  
  resetVMSelections() {
    this.availableVMs.forEach(vm => vm.selected = false);
    this.selectedVMs = [];
  }
  
  toggleHostSelection(host: any) {
    host.selected = !host.selected;
    this.updateSelectedHosts();
  }
  
  updateSelectedHosts() {
    this.selectedHosts = this.availableHosts.filter(host => host.selected);
  }
  
  toggleVMSelection(vm: any) {
    vm.selected = !vm.selected;
    this.updateSelectedVMs();
  }
  
  updateSelectedVMs() {
    this.selectedVMs = this.availableVMs.filter(vm => vm.selected);
  }

  getHostsAndMachinesFromKvm(friendlyName){
    this.spinner.show('addDeployment');
    this.depService.getHostsAndVmsFromKvm(friendlyName)
    .subscribe({
      next: (data) => {
        if(data) {
          let objData = JSON.parse(JSON.stringify(data));
          if(objData) {
            this.availableHosts = objData?.kvmHardwareHosts;    
            this.availableVMs = objData?.kvmVirtualMachines;
          }
        } 
        else{
          this.spinner.hide('addDeployment');
        }
      },
      error: (err) => {
        console.error(err);
        this.snackbar.open(err?.error?.actionMessage || "Something went wrong.", 'Ok', { duration: 3000 });
        this.spinner.hide('addDeployment');
      },
      complete:() => {
        this.spinner.hide('addDeployment');
      }
    })
  }

  onNodeTabEnter() {
    try{
      this.spinner.show();
      if (this.deploymentForm.get('deployment.syncKvm').value === true) {
        this.setSyncVMs(true);
      }
    }
    catch(e){
      this.spinner.hide();
      console.error(e);
    }
    finally {
      this.spinner.hide();
    }
  }

  initializeNodeTabData() {
    this.selectedHosts = [];
    this.selectedVMs = [];
  }

  canProceedToNextTab(): boolean {
    switch(this.activeTabIndex) {
      case 0:
        return this.deploymentForm.get('deployment').valid;
      case 1:
        return this.isNodeTabEnabled;
      default:
        return true;
    }
  }

  onSelectAllCheckBox(event) {
    let filteredNodes = this.applyFilter();
    if (event.target.checked) {
      filteredNodes?.forEach((node, i) => {
        if (!this.multiSelectIndex.includes(node.vmNames)) {
          this.multiSelectIndex.push(node.vmNames);
        }
      });
      if (filteredNodes?.length == this.availableVMs.length) {
        this.isSelectAll = true;
      }
      if(this.multiSelectIndex) {
        this.selectedVMs = this.availableVMs.filter((vm) => this.multiSelectIndex.includes(vm.vmNames));
      }
      return;
    } else {
      filteredNodes?.forEach((node, i) => {
        if (this.multiSelectIndex.includes(node.vmNames)) {
          let index = this.multiSelectIndex.indexOf(node.vmNames);
          if (index !== -1) {
            this.multiSelectIndex.splice(index, 1);
          }
        }
      });
      if (filteredNodes?.length == this.availableVMs.length) {
        this.isSelectAll = false;
      }
      if(this.multiSelectIndex) {
        this.selectedVMs = this.availableVMs.filter((vm) => this.multiSelectIndex.includes(vm.vmNames));
      }
      return;
    }
  }

  checkSelectedCheckboxes(event, nodeName) {
    if (event.target.checked) {
      if (!this.multiSelectIndex.includes(nodeName)) {
        this.multiSelectIndex.push(nodeName);
        if (this.multiSelectIndex.length == this.availableVMs.length) {
          this.isSelectAll = true;
        }
      }
    } else {
      let idx = this.multiSelectIndex.indexOf(nodeName);
      this.multiSelectIndex.splice(idx, 1);
      if (
        this.multiSelectIndex.length == 0 ||
        this.multiSelectIndex.length != this.availableVMs.length
      ) {
        this.isSelectAll = false;
      }
    }

    if(this.multiSelectIndex) {
      this.selectedVMs = this.availableVMs.filter((vm) => this.multiSelectIndex.includes(vm.vmNames));
    }
  }

  applyFilter() {
    this.filtersApplied = true;
    this.filteredWorkstations = this.availableVMs;
    if (this.filterText && this.filterText != "") {
      this.filteredWorkstations = this.filteredWorkstations.filter((nd) =>
        nd.vmNames.toLowerCase().includes(this.filterText.toLowerCase())
      );
    }
    return this.filteredWorkstations;
  }
}
